<template>
  <div class="w-full bg-white">
    <label-form v-if="label" :text="label"/>

    <datepicker
      :language="ptBR"
      :placeholder="placeholder"
      :format="'dd/MM/yyyy'"
      :clear-button="true"
      clear-button-icon="fa fa-times text-gray-500 text-right"
      class="date-picker-component relative w-full form-input border border-solid border-black rounded-md text-xs pl-3 h-10 flex items-center  focus:outline-0 focus:border-0"
      v-model="selectedDate"
      @input="$emit('input', moment(selectedDate) || null)"
      name="operation_date"
    />
  </div>
</template>

<script>
import JetDatePicker from "../../../Jetstream/DatePicker";
import LabelForm from './Label'
import moment from 'moment/dist/moment';
import ptBR from 'vuejs-datepicker/dist/locale/translations/pt-BR.js';
import eventBus from "/resources/js/Layouts/eventBus.vue";

export default {
    components: {
      JetDatePicker,
      LabelForm
    },
    props: {
      value: [String, Object, Boolean, Number, Array],
      placeholder: {
        type: String,
        default: 'Selecione uma Data'
      },
      label: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        ptBR,
        selectedDate: this.value,
      }
    },
    methods: {
      moment(data) {
        return data ? moment.utc(data).format('yyyy-MM-DD\T00:00:00') : null;
      }
    },
    created() {
        eventBus.$on("clearFilter", () => {
          this.selectedDate = null;
          this.$emit('input', null);
        });
    }
}

</script>

<style>
  .date-picker-component > div:first-child {
    width: 100%;
  }
</style>